<div class="grid mt-2 ml-2">
  <i class="pi pi-info-circle" style="font-size: 1.5rem"></i>
  <div class="ml-2">
    <p>
      Are you sure you want to delete
      <span class="font-bold">{{ data?.title ? data.title + '?' : 'this record?' }}</span>
    </p>
    <p *ngIf="data?.information">{{ data.information }}</p>
  </div>
</div>
<div class="flex justify-content-end mt-4">
  <button pButton icon="pi pi-times" label="No" (click)="deleteConfirmation(false)" class="p-button-text mb-2 mr-4"></button>
  <button pButton icon="pi pi-check" label="Yes" (click)="deleteConfirmation(true)" class="p-button-primary mb-2"></button>
</div>

<!-- <app-confirm-dialog
    [message]="'Are you sure you want to delete this record?'"
></app-confirm-dialog> -->
